"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var login_1 = require("./login");
var logout_1 = require("./logout");
var pkceToken_1 = require("./pkceToken");
var token_1 = __importDefault(require("./token"));
var assert_1 = require("./utils/assert");
var redirect_1 = require("./utils/redirect");
var randomString_1 = require("./utils/randomString");
exports.defaultOptions = {
    client_id: '',
    enableTokenRefresh: false,
    onLoginRedirect: redirect_1.redirect,
    onLogoutRedirect: redirect_1.redirect,
    redirect_url: '',
    url: '',
};
function clearRedirectResponse() {
    if (window.history && window.history.replaceState) {
        var url = window.location.href.replace(window.location.hash, '');
        window.history.replaceState(null, '', url);
    }
    else {
        window.location.hash = '';
    }
}
var Auth = (function () {
    function Auth(options) {
        assert_1.assert(options, ['client_id', 'url', 'redirect_url']);
        this.options = __assign(__assign({}, exports.defaultOptions), options);
    }
    Auth.prototype.init = function (tokenish) {
        var token = this.getRedirectResponse();
        if (token) {
            return token;
        }
        var convertedToken = tokenish && new token_1.default(tokenish);
        if (convertedToken && convertedToken.isValid()) {
            return this.bindToken(convertedToken);
        }
        return undefined;
    };
    Auth.prototype.getRedirectResponse = function (hash) {
        if (hash === void 0) { hash = window.location.hash; }
        if (hash) {
            var token = new token_1.default(hash);
            if (token.isValid()) {
                clearRedirectResponse();
                return this.bindToken(token);
            }
        }
        return undefined;
    };
    Auth.prototype.login = function (options) {
        if (options === void 0) { options = {}; }
        return login_1.login(__assign(__assign({}, this.options), options));
    };
    Auth.prototype.loginWithSSO = function (options) {
        if (options === void 0) { options = {}; }
        return login_1.loginWithSSO(__assign(__assign({}, this.options), options));
    };
    Auth.prototype.loginWithPKCE = function (options) {
        if (options === void 0) { options = {}; }
        return login_1.loginWithPKCE(__assign(__assign({}, this.options), options));
    };
    Auth.prototype.requestPKCEToken = function (options) {
        if (options === void 0) { options = {}; }
        return pkceToken_1.requestPKCEToken(__assign(__assign({}, this.options), options));
    };
    Auth.prototype.storeTokenObject = function (token) {
        if (token.isValid()) {
            return this.bindPKCEToken(token);
        }
        return undefined;
    };
    Auth.prototype.logout = function (options) {
        if (options === void 0) { options = {}; }
        return logout_1.logout(__assign(__assign({}, this.options), options));
    };
    Auth.prototype.bindToken = function (token) {
        var _this = this;
        if (this.options.enableTokenRefresh) {
            token
                .startRefreshTimer(this.options.tokenRefreshTimestamp)
                .then(this.options.onTokenRefresh)
                .then(function () { return _this.login(); });
        }
        this.bindLogoutToToken(token);
        return token;
    };
    Auth.prototype.bindPKCEToken = function (token) {
        var _this = this;
        if (this.options.enableTokenRefresh) {
            token
                .startRefreshTimer(this.options.tokenRefreshTimestamp)
                .then(this.options.onTokenRefresh)
                .then(function () { return _this.loginWithPKCE(); });
        }
        this.bindLogoutToToken(token);
        return token;
    };
    Auth.prototype.bindLogoutToToken = function (token) {
        var _this = this;
        var tokenLogout = token.logout;
        Object.defineProperty(token, 'logout', {
            enumerable: false,
            value: function () {
                tokenLogout.call(token);
                _this.logout();
            },
        });
    };
    Auth.prototype.randomString = function (strLength) {
        return randomString_1.randomString(strLength);
    };
    return Auth;
}());
exports.default = Auth;
//# sourceMappingURL=auth.js.map